import React, { useEffect, useState } from "react";
import DashboardLayout from "../layout/Dashboard";
import { FormattedMessage } from "react-intl";
import { getEmailCampaignDetails as getEmailCampaignDetailsApi } from "../../api/emailCampaigns/emailCampaigns";
import { Messages } from "../../components/layout/Messages/Messages";
import {
  NOTIFICATION_EMAIL_CAMPAIGN_ACTIONS,
  NOTIFICATION_VIEW_EMAIL_CAMPAIGN,
} from '../../config/notifications';
import { EmailCampaignDetailsComponent } from "../../components/pages/emailCampaigns/EmailCampaignDetails";
import { SendEmailCampaign } from "../../components/pages/emailCampaigns/actionButtons/SendEmailCampaign";
import { ROUTE_CLIENT_EMAIL_CAMPAIGNS } from "config/routes";
import { history } from "../../store/store";
import {
  PageHeader,
  PageSurface,
  PageWorkspace
} from '../../components/layout/Workspace';
import './ViewEmailCampaign.scss';

function ViewEmailCampaignComponent(props) {
  const { emailCampaignId } = props.match.params;
  const [ emailCampaign, setEmailCampaign ] = useState( null );

  useEffect( () => {
    getEmailCampaign( emailCampaignId );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] );

  /**
   * Get email campaign details
   * @param {string} [emailCampaignId]
   */
  const getEmailCampaign = (emailCampaignId) => {
    getEmailCampaignDetailsApi( {
      data: {
        emailCampaignId: emailCampaignId,
      },
      notificationId: NOTIFICATION_VIEW_EMAIL_CAMPAIGN,
    } ).then( (response) => {
      if (response && response.data && response.data.id) {
        setEmailCampaign( response.data );
      }
    } );
  };

  return (
    <DashboardLayout location={props.location} className="dashboard" workspace>
      <PageWorkspace className="view-email-campaign-workspace">
        <PageHeader
          actions={(
            <SendEmailCampaign
              emailCampaign={emailCampaign}
              actionCallback={() => history.push( ROUTE_CLIENT_EMAIL_CAMPAIGNS )}
            />
          )}
          title={<FormattedMessage id="pages.emailCampaigns.title"/>}
        />
        <div className="view-email-campaign-notifications">
          <Messages notificationId={NOTIFICATION_EMAIL_CAMPAIGN_ACTIONS}/>
          <Messages notificationId={NOTIFICATION_VIEW_EMAIL_CAMPAIGN}/>
        </div>
        <PageSurface className="view-email-campaign-surface">
          <EmailCampaignDetailsComponent
            location={props.location}
            emailCampaign={emailCampaign}
          />
        </PageSurface>
      </PageWorkspace>
    </DashboardLayout>
  );
}

export { ViewEmailCampaignComponent };
